import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

import {
  BackgroundColor,
  CardsCarouselCard,
  ServiceDetails,
} from '@digital-platform/rs-cms/domain';
import { CardsCarouselComponent } from '@digital-platform/rs-cms/feature-ptypes';
import {
  bgCarouselColor,
  richTextCardStart,
  richTextCardEnd,
  richTextCardMiddle,
  richTextHeaderTitle,
} from '@digital-platform/rs-frontend/domain';

@Component({
  selector: 'digital-platform-facility-services-available',
  standalone: true,
  imports: [CommonModule, CardsCarouselComponent],
  templateUrl: './facility-services-available.component.html',
})
export class FacilityServicesAvailableComponent implements OnInit {
  public bgColor: BackgroundColor = bgCarouselColor;
  public richTextTitle = richTextHeaderTitle;
  public cardsCarouselCard: CardsCarouselCard[] = [];
  public showAccordian = true;

  @Input() public servicesAvailable: ServiceDetails[] = [];

  ngOnInit(): void {
    this.createCardsCarouselCard(this.servicesAvailable);
  }

  private createCardsCarouselCard(
    servicesAvailable: ServiceDetails[]
  ): CardsCarouselCard[] {
    for (const service of servicesAvailable) {
      const newCard: CardsCarouselCard = {
        id: undefined,
        uuid: '',
        revisionId: undefined,
        type: 'cardsCarouselCard',
        status: true,
        parentType: '',
        behaviorSettings: [],
        bgColor: null,
        carouselCardType: null,
        ctaButton: service.ctaButton,
        inlineImage: null,
        richTextTitle: `${richTextCardStart}${
          service.service ?? 'No services available'
        }${richTextCardMiddle}${service.description ?? ''}${richTextCardEnd}`,
        svgIconClass: {
          tid: 0,
          name: '',
          iconClass: service.icon,
        },
        iconSize: null,
      };
      this.cardsCarouselCard.push(newCard);
    }
    return this.cardsCarouselCard;
  }
}
